class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');

    // S2G: move cart notification to body so it is not trapped behind header/gallery stacking contexts.
    if (this.parentElement !== document.body) {
      document.body.appendChild(this);
    }
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    document.body.classList.add('s2g-cart-notification-open');
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.classList.remove('s2g-cart-notification-open');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {
        const target = document.getElementById(section.id);
        if (!target || !parsedState.sections || !parsedState.sections[section.id]) return;
        target.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      this.updateSubtotal();
      this.renderUpsell(parsedState);
      if (this.header) this.header.reveal();
      this.open();
  }

  updateSubtotal() {
    const subtotal = document.getElementById('s2g-cart-notification-subtotal');
    const count = document.getElementById('s2g-cart-notification-count');
    if (!subtotal && !count) return;

    fetch(`${window.Shopify && Shopify.routes ? Shopify.routes.root : '/'}cart.js`)
      .then((response) => response.ok ? response.json() : null)
      .then((cart) => {
        if (!cart) return;
        if (subtotal) {
          if (window.Shopify && typeof Shopify.formatMoney === 'function') {
            subtotal.textContent = Shopify.formatMoney(cart.total_price, window.theme?.moneyFormat || '${{amount}}');
          } else {
            subtotal.textContent = (cart.total_price / 100).toLocaleString(undefined, { style: 'currency', currency: cart.currency || 'GBP' });
          }
        }
        if (count) {
          const n = cart.item_count || 0;
          count.textContent = `(${n} item${n === 1 ? '' : 's'})`;
        }
      })
      .catch(() => {});
  }

  renderUpsell(parsedState) {
    const wrapper = document.getElementById('s2g-cart-upsell');
    if (!wrapper) return;

    const grid = wrapper.querySelector('.s2g-cart-upsell__grid');
    if (!grid) return;

    wrapper.classList.remove('is-visible');
    grid.innerHTML = '';

    const productId = parsedState && (parsedState.product_id || (parsedState.items && parsedState.items[0] && parsedState.items[0].product_id));
    if (!productId) return;

    fetch(`${window.Shopify && Shopify.routes ? Shopify.routes.root : '/'}recommendations/products.json?product_id=${productId}&limit=3&intent=related`)
      .then((response) => response.ok ? response.json() : null)
      .then((data) => {
        const products = data && data.products ? data.products : [];
        if (!products.length) return;

        grid.innerHTML = products.slice(0, 3).map((product) => {
          const image = product.featured_image || (product.images && product.images[0]);
          const imageUrl = image ? (typeof image === 'string' ? image : image.url) : '';
          const title = product.title || '';
          const url = product.url || `/products/${product.handle}`;
          return `
            <a class="s2g-cart-upsell__item" href="${url}">
              ${imageUrl ? `<img class="s2g-cart-upsell__image" src="${imageUrl}" alt="${title.replace(/"/g, '&quot;')}" loading="lazy">` : ''}
              <span class="s2g-cart-upsell__name">${title}</span>
            </a>
          `;
        }).join('');
        wrapper.classList.add('is-visible');
      })
      .catch(() => {});
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const element = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
    return element ? element.innerHTML : '';
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target.classList && target.classList.contains('s2g-cart-notification-overlay')) {
      this.close();
      return;
    }
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
